import React from "react";
import "./Terms.css";

function Terms() {
  return (
    <div>
      <h1>利用規約</h1>
      <p>
        この利用規約（「本規約」）は作田陽樹（「事業者」）が本アプリで提供するサービス（「本サービス」）の利用条件を定めるものです。
        利用者の皆様には、本規約に従って本アプリ及び本サービスをご利用いただきます。
        <br />
        <br />
        <h2>第1条（定義）</h2>
        <p>
          本規約において使用する以下の用語は、それぞれ以下の意味を有するものとします。
          <br />
          「コンテンツ」とは、文章、音声、音楽、画像、ソフトウェア、プログラム、コード、その他の情報のことをいいます。
          <br />
          「対象商品」とは、事業者が本アプリを通じて販売する物品又はサービスをいいます。
          <br />
          「デバイス」とは、パーソナルコンピュータ、スマートフォン、タブレット等、利用者が本アプリ及び本サービスを利用するための機器のことをいいます。
          <br />
          「本アプリ」とは、事業者が提供する下記アプリケーションソフトウェアをいいます。
          <br />
          LIFE
          MISSIONは、利用者の生活の質を向上しサポートすることを目的とし、行うべきことのWEEK
          ToDo、
          MISSION等のシステムを、向上意識がある個人を対象に提供し、日々の生活に役立てることを目的としています。
          iOS15以上に対応しており、スマートフォンでご利用いただけます。
          <br />
          「本コンテンツ」とは、その作成者・投稿者・送信者・アップロードした者が誰であるかを問わず、本サービスを通じてアクセスできるあらゆるコンテンツのことをいいます。
          <br />
          「反社会的勢力等」とは、暴力団、暴力団員、右翼団員、その他これに準じる者をいいます。
          <br />
          「登録事項」とは、本サービスのサブスクリプション登録希望者がサブスクリプション登録申請をするために事業者に提供する必要がある事項として、
          事業者が定める事項をいいます。登録事項には、下記の事項及び事業者が必要に応じて定める下記以外の事項を含みます。
          <br />
          住所、氏名、メールアドレス、携帯番号、料金支払いに関する情報（銀行口座情報、クレジットカード情報など）
        </p>
        <h2>第2条（本規約への同意）</h2>
        <p>
          2.1　利用者は、本規約に同意した場合のみ、本アプリ及び本サービスを利用できるものとします。利用者は、ログインをすることにより本規約に同意するものとします。
          <br />
          2.2　事業者は、本規約の他、本アプリ及び本サービス利用のルール・条件・ガイドライン等（「個別規定」）を定めることがあります。利用者は、本規約及び個別規定に従って本アプリ及び本サービスを利用しなければなりません。
          <br />
          2.3　利用者が未成年者である場合は、下記のとおりとします。
          <br />
          （1）親権者等の法定代理人の同意を得た上で本アプリ及び本サービスを利用してください。
          <br />
          （2）未成年者の利用者が、法定代理人の同意がないにもかかわらず同意があると偽り、又は年齢について成年と偽って本アプリ又は本サービスを利用した場合、その他能力者であると信じさせるために詐術を用いた場合は、本サービスに関する一切の法律行為を取り消すことはできません。
          <br />
          （3）本規約への同意時に未成年であった利用者が、成年に達した後に本アプリ又は本サービスを利用した場合は、当該利用者は本アプリ及び本サービスに関する一切の法律行為を追認したものとみなします。
        </p>
        <h2>第3条（サブスクリプションサービス）</h2>
        <p>現在、サブスクリプションサービスは提供しておりません。</p>
        {/* <p>
          3.1　利用者は、有料で、又は事業者所定の条件で、本サービスを一定期間利用するために一定の対価を支払うサービス（サブスクリプションサービス）の提供を受けることができます。サブスクリプションサービス登録者は、本規約又は本アプリ内に掲載されるサブスクリプションサービスの利用期間、利用料、決済方法、その他の利用条件に従うものとします。
          <br />
          3.2　利用者がサブスクリプションサービスの利用料の支払を遅滞した場合（クレジットカードのエラー等による決済手続の不能を含む）、事業者は、当該利用者がサブスクリプションサービスの利用を停止したものとみなすことができます。
          <br />
          3.3　前項に関わらず、事業者はその裁量により、特定のサブスクリプションサービスを終了することができるものとし、これによって利用者に損害が生じた場合でも事業者は損害賠償責任を負いません。
          <br />
          3.4　利用者は、次条に従ってサブスクリプションサービスの利用料を支払うものとし、いったん支払った利用料金の返金を求めることはできません。また、サブスクリプションサービスが利用期間の途中で終了した場合であっても、利用者は事業者に対して返金を求めることはできません。
          <br />
          3.5　サブスクリプションサービスにおいては、利用者が本規約に同意の上、登録事項を事業者の定める方法によって事業者に提供してサブスクリプション登録申請をし、事業者がこれを承認することによって、サブスクリプション登録が完了するものとします。事業者は、サブスクリプション登録の申請者に以下の各号のいずれかの事由があると事業者が判断した場合は、サブスクリプション登録の申請を承認しないことがあり、その理由について一切の開示義務を負わないものとします。
          <br />
          （1） 登録事項に虚偽、誤記、又は記載漏れがあった場合
          <br />
          （2）
          申請者が未成年者、成年被後見人、被保佐人、又は被補助人であり、法定代理人、後見人、保佐人、又は補助人の同意等を得ていなかった場合
          <br />
          （3）
          申請者が反社会的勢力等である場合、又は資金提供その他を通じて反社会的勢力等の維持、運営、又は経営に協力又は関与する等、反社会的勢力等と何らかの交流又は関与を持っている場合
          <br />
          （4） 本規約に違反したことがある者、又はその関係者からの申請である場合
          <br />
          （5） その他、事業者がサブスクリプション登録を相当でないと判断した場合
          <br />
          3.6　利用者は、登録事項に変更が生じた場合は直ちにアップデートすることとし、常に真実、正確、完全、かつ最新の情報となるよう維持しなければなりません。
          <br />
          3.7　利用者は、下記方法により、本サービスのサブスクリプション登録から退会できるものとします。
          <br />
          Apple
          の設定アプリからサブスクリプションの解除を行うことで退会を終えることとする。なお、退会後に、再度入会する場合、その時に提示してあるプラン、料金でのみ利用できるものとします。
          <br />
          3.8　利用者は、自己の責任において、サブスクリプション登録に関するユーザーID及びパスワードを適切に管理及び保管しなければなりません。ユーザーID及びパスワードは利用者に一身専属的に帰属するものとし、これを第三者に利用させ、又は第三者と共有し、又は貸与・譲渡・名義変更・売買等をしてはならず、相続することもできません。
          <br />
          3.9　事業者は、ユーザーID及びパスワードが入力されて本サービスの利用が行われた場合は、当該ユーザーIDの登録利用者本人が本サービスを利用したものと扱うことができるものとします。
          <br />
          3.10　ユーザーID又はパスワードの管理不十分、使用上の過誤、第三者の使用等によって生じた損害については、利用者が負担するものとします。
        </p> */}
        <h2>第4条（利用料金及び支払方法）</h2>
        <p>
          4.1　利用者は、本サービスの有料部分の対価として、下記の利用料金を、事業者が指定する方法により支払うものとします。
          <br />
          利用料：無料
          <br />
          4.2　利用者が利用料金の支払を遅滞した場合は、利用者は年10%の割合による遅延損害金を支払うものとします。
        </p>
        <h2>第5条（禁止事項）</h2>
        <p>
          利用者は、本アプリ又は本サービスの利用にあたり、以下の行為又はこれらを助長する行為をしてはならず、また、これらの行為を試みてはなりません。
          <br />
          1　法令、公序良俗、又は事業者若しくは利用者が所属する業界団体の内部規則に違反する行為
          <br />
          2　犯罪行為に関連する行為
          <br />
          3　本アプリ又は本サービスを通じて下記に該当すると事業者が判断する情報を投稿・送信・アップロードする行為
          <br />
          （1） 過度に暴力的又は残虐な表現を含む情報
          <br />
          （2）
          事業者、他の利用者、又は第三者の名誉又は信用を毀損する表現を含む情報
          <br />
          （3）
          過度にわいせつな表現又は児童ポルノ・児童虐待にあたる表現を含む情報
          <br />
          （4） 差別を助長する表現を含む情報
          <br />
          （5） 自殺、自傷行為を助長する表現を含む情報
          <br />
          （6） 薬物の不適切な利用を助長する表現を含む情報
          <br />
          （7） 反社会的な表現を含む情報
          <br />
          （8） チェーンメール等の第三者への情報の拡散を求める情報
          <br />
          （9） 他人に不快感を与える情報を含む情報
          <br />
          4　事業者、他の利用者、その他の第三者の知的財産権、肖像権、プライバシー権、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含む）
          <br />
          5　事業者又は第三者に対する詐欺又は脅迫行為、名誉又は信用毀損行為、不当な差別又は誹謗中傷行為
          <br />
          6　事業者、他の利用者、又は第三者のサーバー又はネットワークの機能を破壊したり、妨害したりする行為
          <br />
          7　コンピューターウィルス、その他の有害なコンピュータープログラムを含む情報を送信する行為
          <br />
          8　本アプリ又は本サービスにおいて利用し得る情報を改ざんする行為
          <br />
          9　事業者が定める一定のデータ容量以上のデータを本アプリ又は本サービスを通じて送信する行為
          <br />
          10　事業者による本アプリ又は本サービスの運営を妨害するおそれのある行為
          <br />
          11　不正アクセスをし、又はこれを試みる行為
          <br />
          12　他の利用者又は第三者になりすます行為
          <br />
          13　他の利用者のID又はパスワードを利用する行為
          <br />
          14　他の利用者に関する個人情報等を収集又は蓄積する行為
          <br />
          15　不正な目的を持って本アプリ又は本サービスを利用する行為
          <br />
          16　本アプリ又は本サービスの他の利用者又は第三者に不利益、損害、不快感を与える行為
          <br />
          17　事業者が許諾しない本アプリ又は本サービス上での宣伝、広告、勧誘、又は営業行為
          <br />
          18　本アプリ又は本サービスに関連して、反社会的勢力等に対して直接又は間接に利益を供与する行為
          <br />
          19　その他、事業者が不適切と判断する行為
        </p>
        <h2>第6条（本アプリ及び本サービスの提供の停止等）</h2>
        <p>
          6.1　事業者は、以下のいずれかの事由があると判断した場合、利用者に事前に通知することなく本アプリ及び本サービスの全部又は一部の提供を停止又は中断することができるものとします。
          <br />
          （1）
          本アプリ又は本サービスにかかるコンピュータシステムの保守点検又は更新を行う場合
          <br />
          （2）地震、落雷、火災、又は停電などの不可抗力により、本アプリ又は本サービスの提供が困難となった場合
          <br />
          （3） コンピュータ又は通信回線等が事故により停止した場合
          <br />
          （4） その他、事業者が本アプリ又は本サービスの提供が困難と判断した場合
          <br />
          6.2　事業者は、事業者の都合により、いつでも本アプリ及び本サービスの提供を終了することができます。
          <br />
          6.3　事業者は、本アプリ又は本サービスの提供の停止又は中断により、利用者又は第三者が被ったいかなる不利益又は損害についても、一切の責任を負わないものとします。
        </p>
        <h2>第7条（利用制限及び登録抹消）</h2>
        <p>
          7.1　事業者は、利用者が以下のいずれかに該当すると事業者が判断した場合は、事前の通知をせずに、利用者に対して、当該利用者に関する表示を削除又は非表示にし、本アプリ及び本サービスの全部もしくは一部の利用を制限又は一時停止し、又は利用者としての登録を抹消することができるものとします。
          <br />
          （1） 本規約のいずれかの条項に違反した場合
          <br />
          （2） 登録事項に虚偽の事実があることが判明した場合
          <br />
          （3）事業者、他の利用者、又は第三者に損害を生じさせるおそれのある目的又は方法で本アプリ又は本サービスを利用した、又は利用しようとした場合
          <br />
          （4） 本アプリ又は本サービスの運営を妨害した、又は妨害しようとした場合
          <br />
          （5） 料金等の支払債務の不履行があった場合
          <br />
          （6）
          支払停止又は支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始、又はこれらに類する手続の開始の申立があった場合
          <br />
          （7）
          自ら振出し、又は引受けた手形若しくは小切手につき、不渡処分を受けた場合、又は手形交換所の取引停止処分、その他これに類する措置を受けたとき
          <br />
          （8） 差押、仮差押、仮処分、強制執行、又は競売申立があった場合
          <br />
          （9） 公租公課の滞納処分を受けた場合
          <br />
          （10）
          死亡した場合、又は後見開始、保佐開始、若しくは補助開始の審判を受けた場合
          <br />
          （11） 事業者からの連絡に対し、一定期間返答がない場合
          <br />
          （12） 本サービスについて、最終の利用から一定期間利用がない場合
          <br />
          （13）
          上記の他、事業者が本アプリ及び本サービスの利用又は利用者としての登録の継続を適当でないと判断した場合
          <br />
          7.2　前項各号のいずれかの事由に該当した場合、当該利用者は、事業者に対して負っている全ての債務につき当然に期限の利益を喪失し、直ちに全ての債務を履行しなければなりません。
          <br />
          7.3　事業者は、本条に基づき事業者が行った行為により利用者に生じた損害について、一切の責任を負いません。
        </p>
        <h2>第8条（利用環境の整備）</h2>
        <p>
          8.1　利用者は、本アプリ及び本サービスの利用に必要となるデバイス、ソフトウェア、通信回線、その他の環境を、利用者の責任と負担において準備するものとします。
          <br />
          8.2　本アプリ及び本サービスの利用に伴い発生する通信料は、利用者の負担とします。
          <br />
          8.3　利用者は、本アプリをインストールしたデバイスを処分する場合、又は本アプリの使用を終了する場合、本アプリを必ず削除するものとします。
        </p>
        <h2>第9条（保証の否認）</h2>
        <p>
          9.1　事業者は、本アプリ又は本サービス並びに対象商品が利用者の特定の目的に適合すること、利用者が期待する機能・商品的価値・正確性・有用性・信頼性・完全性・安全性を有していること、利用者に対して適用のある法令又は業界団体内部規則等に適合すること、継続的な利用ができること、欠陥・エラー・バグがないこと、利用者又は第三者の権利侵害が生じないこと、及び不具合が生じないことにつき、明示又は黙示を問わず、何ら保証するものではありません。
          <br />
          9.2　事業者が外部のSNS事業者又はその他の第三者サービス提供者と連携した場合でも、事業者はその連携の可能性や継続性を保証するものではなく、また、本アプリ及び本サービスの利用がこれらの外部事業者の利用規約に違反しないことについても保証するものではありません。外部事業者の利用規約の遵守は、利用者が自らの費用及び責任で行ってください。
          <br />
          9.3　本アプリにおいて、アフィリエイトプログラムやブログ記事等により商品が紹介された場合、その商品に関するお問合せは事業者に対しては行わず、販売者様へ直接行ってください。本アプリからリンクやバナー等により他サイトに移動された場合の移動先サイトで提供される情報、サービス等について、事業者は一切の責任を負いません。また、リンク先サイトの正確性、合法性、目的適合性については、一切保証しません。本アプリの記事は作成者の個人的な見解に基づいており、全ての人に該当するわけではありません。商品やサービスの購入に関する最終的な判断は利用者ご自身の責任で行ってください。
        </p>
        <h2>第10条（Cookieの利用について）</h2>
        <p>
          10.1　本アプリでは、広告配信やアクセス解析のためにクッキー（Cookie）を使用することがあります。クッキーとは、ウェブサーバーから利用者のウェブブラウザに送信される小さなデータのことで、利用者のパソコンのハードディスクにファイルとして格納されるものもあります。クッキーには利用者のコンピュータに関する情報や最後にサイトを訪れた日時、訪問回数などを記憶しておくことができますが、特定の個人を識別することはできないよう匿名性が保たれています。クッキーを利用して、第三者配信事業者が利用者に対してパーソナライズド広告を配信することがあります。
          <br />
          10.2　利用者ご自身でブラウザの設定を変更することにより、クッキーの受け取りを拒否することも可能です。この場合、本サービスの利用は可能ですが、一部の機能が使えなくなる可能性があります。また、第三者配信事業者がパーソナライズド広告掲載のために使用するクッキーは当該事業者のウェブサイト上から無効にすることができますので、該当する第三者配信事業者のウェブサイト又はhttps://optout.aboutads.info/等を参照してください。
        </p>
        <h2>第11条（免責）</h2>
        <p>
          11.1　事業者は、事業者の故意又は過失がある場合を除き、本サービス又は本アプリの利用、又は本サービス又は本アプリの内容の変更、サービス提供の中断、停止、又は終了、サービス利用の不能、利用者が発信するメッセージ又は情報が削除され、又は消失したこと、利用者に対する利用制限措置又は登録抹消措置、本サービス又は本アプリのデータ消失又はデバイスの故障・損傷、本サービス又は本アプリがデバイスに与える影響、利用者が本サービス又は本アプリを正常に利用することができないことにより被る不利益、データ消失の不利益、その他本アプリ又は本サービスに起因し、又は関連して利用者が受けたあらゆる損害について、一切の責任を負いません。
          <br />
          11.2　事業者が本サービスの利用に関し損害賠償責任を負う場合、事業者に故意又は重過失がある場合を除き、事業者が負う損害賠償責任は10万円を上限とする。
          <br />
          11.3　事業者は、本アプリ及び本サービスに関して、利用者同士、又は利用者と利用者以外の第三者との間で生じた取引、連絡、紛争等につき、一切の責任を負いません。
        </p>
        <h2>第12条（本コンテンツ及び本アプリの権利）</h2>
        <p>
          本アプリ及び本サービスに関する知的財産権は全て事業者又は事業者にライセンスを許諾している者に帰属しており、本規約に基づき本アプリ及び本サービスの利用を許諾されることは、本サービスに関する事業者又は事業者にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。利用者は、いかなる理由によっても事業者又は事業者にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリング等を含む）をしてはいけません。
        </p>
        <h2>第13条（利用者からのフィードバック）</h2>
        <p>
          13.1　利用者が本アプリ又は本サービスの改善策に関するフィードバックを事業者に送付する場合、利用者は当該フィードバックが第三者の知的財産権（特許権、著作権、商標権等）を侵害していないこと、利用者が当該フィードバックを事業者に伝える権利を有すること、及び事業者に当該フィードバックを利用させる権利を有することを表明保証するものとします。
          <br />
          13.2　利用者は、事業者に対し、事業者が利用者から受領したフィードバックを利用する権利を無償かつ無期限に、地域の限定なく許諾したこととし、事業者はかかる権利を取得します。事業者が取得する権利には、複製、上映、演奏、公衆送信、公衆伝達、口述、展示、頒布、譲渡、貸与、翻訳、翻案、事業者が事業目的上必要とみなす範囲での改変、著作権法27条及び28条に定める権利を含みます。利用者は、事業者及び事業者から権利を承継し又は許諾された者に対して、著作者人格権を行使しないことに同意するものとします。
        </p>
        <h2>第14条（知的財産権）</h2>
        <p>
          14.1　本アプリ及び本サービスに関連する全てのコンテンツの著作権及びその他の知的財産権は、事業者または正当な権利を有する第三者に帰属します。利用者は、事業者の事前の書面による承諾なくして、これらのコンテンツを複製、変更、配布、公表、商業目的で使用することはできません。
          <br />
          14.2　本アプリ及び本サービスに含まれる商標、ロゴ、サービスマークは、事業者の登録商標または商標であり、未承諾の使用を固く禁じます。これらは、事業者の明示的な事前の書面による同意なくして使用することはできません。
          <br />
          14.3　事業者は、利用者に対し、本アプリ及び本サービスを個人的な非商業目的で利用する非独占的な権利のみを付与します。このライセンスは、本規約に従うことを条件とします。利用者が本規約に違反した場合、このライセンスは自動的に終了します。
          <br />
          14.4　事業者は、著作権を尊重し、著作権侵害の申し立てに対して真摯に対応します。著作権者またはその代理人が、本アプリまたは本サービス上で提供されるコンテンツが著作権を侵害していると信じる場合は、事業者に対して通知することができます。詳細な手続きについては、18条2に記載された方法で事業者にお問い合わせください。
        </p>
        <h2>第15条（本規約の変更）</h2>
        <p>
          15.1　事業者は、必要と判断した場合には、いつでも本規約を変更することができるものとします。
          <br />
          15.2　事業者は、本規約を変更したときは、利用者のメールアドレスに送信する方法により利用者に通知するものとし、同通知には変更後の規約の効力発生日を明記するものとします。
          <br />
          15.3　本規約の変更が利用者の一般の利益に適合するとともに本規約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、その他の変更に係る事情に照らして合理的なものであるときは、本規約の変更は、利用者の合意がなくても通知に記載された効力発生日から生じるものとします。
          <br />
          15.4　本規約の変更が前項の要件を満たさない場合は、本規約の変更は利用者の同意を得たときから効力を生じるものとします。
        </p>
        <h2>第16条（個人情報の取扱い）</h2>
        <p>
          事業者が本アプリ又は本サービスの利用によって取得する個人情報の取扱いについては本規約には規定せず、事業者が別途定めるプライバシーポリシーに従うものとします。プライバシーポリシーの内容は下記リンクから確認できます：https://finalquestx.com/life_mission/privacy_policy
        </p>
        <h2>第17条（通知又は連絡）</h2>
        <p>
          17.1　本アプリ又は本サービスに関する事業者から利用者への通知・連絡は、事業者のウェブサイトへの掲示（https://finalquestx.com/）、又は事業者が定めるその他の適切な方法により行うものとします。なお、事業者がその時点で登録されている利用者の連絡先へ連絡をした場合は、その連絡は利用者に到達したものとみなします。
          <br />
          17.2　本アプリ又は本サービスに関する利用者から事業者への連絡は、下記方法、又は事業者が定めるその他の方法により行うものとします。
          <br />
          利用者から事業者への連絡方法：Instagram（_saku_ta）のDMから直接
        </p>
        <h2>第18条（権利義務の譲渡）</h2>
        <p>
          18.1　利用者は、事業者の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利もしくは義務を第三者に譲渡し、又は担保に供することはできません。
          <br />
          18.2　事業者は、利用者にあらかじめ通知することなく、本アプリ及び本サービスにかかる事業を他者に譲渡（事業譲渡、会社分割、会社合併などその態様を問いません）することができ、利用者は本項においてこれに予め同意したものとします。事業者が事業譲渡を行った場合、利用契約上の地位、本規約に基づく権利及び義務、利用者の登録事項、その他の顧客情報を譲受人に譲渡することができます。
        </p>
        <h2>第19条（完全合意）</h2>
        <p>
          本規約は、本規約に含まれる事項に関する事業者と利用者との完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する事業者と利用者の事前の合意、表明、及び了解に優先します。
        </p>
        <h2>第20条（分離可能性）</h2>
        <p>
          本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約のその他の規定、及び一部が無効又は執行不能と判断された規定の残りの部分は継続して完全に効力を有するものとする。また、事業者及び利用者は、当該無効若しくは執行不能とされた条項又は部分が適法かつ執行力を有するために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるよう努めるものとします。
        </p>
        <h2>第21条（準拠法）</h2>
        <p>
          本規約の有効性、解釈、及び履行については日本法に準拠し、日本法に従って解釈されるものとします。
        </p>
        <h2>第22条（合意管轄）</h2>
        <p>
          本規約、本アプリ、又は本サービスに関する一切の紛争については、日本の法令に基づき管轄を有する裁判所を第一審の管轄裁判所とする。
        </p>
      </p>
      <h2>改定日・制定日</h2>
      <p>
        改定日: 2024年11月27日
        <br />
        制定日: 2024年11月27日
      </p>
    </div>
  );
}

export default Terms;
